var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { API } from 'globals/api';
import { DEVICES_END_POINTS } from 'globals/apiEndPoints';
var normalizeWatchBattery = function (metric) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!metric)
        return null;
    var value = (_d = (_c = (_b = (_a = metric.battery_percentage) !== null && _a !== void 0 ? _a : metric.value) !== null && _b !== void 0 ? _b : metric.battery) !== null && _c !== void 0 ? _c : metric.status) !== null && _d !== void 0 ? _d : metric.battery_voltage;
    if (value == null && metric.battery_voltage == null)
        return null;
    return {
        status: (_f = (_e = metric.status) !== null && _e !== void 0 ? _e : metric.battery) !== null && _f !== void 0 ? _f : (metric.battery_voltage == null && value != null
            ? String(value)
            : null),
        value: (_g = metric.battery_percentage) !== null && _g !== void 0 ? _g : value,
        battery_percentage: metric.battery_percentage,
        battery_voltage: metric.battery_voltage,
        synced_at: metric.synced_at,
    };
};
var normalizeMetric = function (metric, value) {
    var _a, _b, _c, _d;
    if (!metric && value == null)
        return null;
    var metricValue = (_d = (_c = (_b = (_a = value !== null && value !== void 0 ? value : ('battery' in (metric || {}) ? metric.battery : undefined)) !== null && _a !== void 0 ? _a : ('battery_voltage' in (metric || {}) ? metric.battery_voltage : undefined)) !== null && _b !== void 0 ? _b : ('network_signal' in (metric || {}) ? metric.network_signal : undefined)) !== null && _c !== void 0 ? _c : metric === null || metric === void 0 ? void 0 : metric.value) !== null && _d !== void 0 ? _d : metric === null || metric === void 0 ? void 0 : metric.status;
    return {
        status: metricValue == null ? null : String(metricValue),
        value: metricValue,
        synced_at: metric === null || metric === void 0 ? void 0 : metric.synced_at,
    };
};
var normalizeMember = function (member) {
    var _a;
    return ({
        senior_id: member.senior_id,
        member_id: member.member_id,
        first_name: member.first_name,
        last_name: member.last_name,
        member_type: member.member_type,
        agency: member.agency,
        watch_battery: normalizeWatchBattery(member.watch_battery) ||
            normalizeWatchBattery(member.watch),
        watch_signal: member.watch_signal ||
            normalizeMetric(member.watch, (_a = member.watch) === null || _a === void 0 ? void 0 : _a.network_signal),
        sleep_mat: normalizeMetric(member.sleep_mat),
        body_scale: normalizeMetric(member.body_scale),
    });
};
export function getDeviceHealthService() {
    return __awaiter(this, arguments, Promise, function (searchQuery, searchType, page, limit) {
        var query, params, response, payload, rawMembers;
        var _a, _b, _c, _d, _e, _f;
        if (searchQuery === void 0) { searchQuery = ''; }
        if (searchType === void 0) { searchType = 'name'; }
        if (page === void 0) { page = 1; }
        if (limit === void 0) { limit = 10; }
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    query = typeof searchQuery === 'string' ? searchQuery.trim() : '';
                    params = {};
                    if (query)
                        params[searchType] = query;
                    params.page = page;
                    params.page_size = limit;
                    return [4 /*yield*/, API({
                            url: DEVICES_END_POINTS.GET_DEVICE_HEALTH,
                            method: 'get',
                            params: params,
                        })];
                case 1:
                    response = _g.sent();
                    payload = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : response.data;
                    rawMembers = Array.isArray(payload)
                        ? payload
                        : (_c = [payload === null || payload === void 0 ? void 0 : payload.members, payload === null || payload === void 0 ? void 0 : payload.items, payload === null || payload === void 0 ? void 0 : payload.data].find(Array.isArray)) !== null && _c !== void 0 ? _c : [];
                    return [2 /*return*/, {
                            summary: Array.isArray(payload) ? {} : (_d = payload === null || payload === void 0 ? void 0 : payload.summary) !== null && _d !== void 0 ? _d : {},
                            members: rawMembers.map(normalizeMember),
                            pagination: Array.isArray(payload)
                                ? undefined
                                : (_e = payload === null || payload === void 0 ? void 0 : payload.pagination) !== null && _e !== void 0 ? _e : (_f = response.data) === null || _f === void 0 ? void 0 : _f.pagination,
                        }];
            }
        });
    });
}
export function getDeviceHealthDetailsService(params) {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, API({
                        url: DEVICES_END_POINTS.GET_DEVICE_HEALTH_DETAILS,
                        method: 'get',
                        params: params,
                    })];
                case 1:
                    response = _d.sent();
                    return [2 /*return*/, (_c = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : response.data) !== null && _c !== void 0 ? _c : {}];
            }
        });
    });
}
